// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
    //suggestionPosition: 'left'
  }
};

(function() {
  BoostPFS.inject(this);

  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function() {};

  SearchInput.prototype.afterBindEvents = function() {
    if(this.id.indexOf('mobile') < 0){
      // not the mobile version ... attach events here
      document.addEventListener('click', function(e) {
        if(this.searchAutoComplete && e && e.target) {
          if(this.id != e.target.getAttribute('id')){
            this.searchAutoComplete.$element[0].parentNode.classList.remove(Class.searchSuggestionOpen);
            document.querySelector('body').classList.remove(Class.searchSuggestionMobileOpen);
          }
        }
      }.bind(this), true);
    }

    // Fix cannot close search suggestion when clicking overlay 
    document.addEventListener('click', function(e) {
      if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
        var $clickedElement = jQ(e.target);
        var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
        if (isClickSuggestion) {
          this.searchAutoComplete.$element.hide();
          this.searchAutoComplete.searchInput.onCloseAutocomplete();
          this.searchAutoComplete.isOpen = false;
        }
      }
    }.bind(this), true);
  }
})();